import { JsonSchemaStateModel } from "../models/json-schema-state";

export class UpdateState {
  public static readonly type = "[Json Schema State] Update State";
  constructor(public state: Partial<JsonSchemaStateModel>) {}
}

export class GetSchema {
  public static readonly type = "[Json Schema State] Get Schema";
  constructor(public name: string) {}
}
